<div class="empty-state-wrap">
  <div class="empty-state-card">

    <div class="empty-state-icon">
      <img class="empty-state-img" src="/assets/e-commerce/icons/95.webp" alt="empty orders" />
    </div>

    <h2 class="empty-state-title">
      {{ "No services" | transloco }}
    </h2>

    <p class="empty-state-subtitle">
      {{ "You have no services yet, start booking now" | transloco }}
    </p>

    <button class="empty-state-btn" routerLink="/clinic">
      {{ "booking" | transloco }}
    </button>
  </div>
</div>